import React from 'react';
import Link from './link';

type Props = {
  style?: any;
  className?: string;
  url: string;
  children?: any;
  href?: any;
  target?: any;
  underlayColor?: any;
  onPress?: (event?: any) => any;
};
export default function LinkHighlight(props: Props) {
  const { children, underlayColor, ...other_props } = props;
  const underlay_extra: any = {
    backgroundColor: underlayColor ?? 'rgba(0,0,0,0.05)',
  };
  return (
    <Link {...other_props}>
      {props.children}
      <div className='base-component-link-underlay' style={underlay_extra} />
    </Link>
  );
}
